import { Key, useState } from 'react';
/* eslint-disable react/destructuring-assignment */
// material-ui
import { styled } from '@mui/material/styles';
import {
    Collapse,
    Box,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Button,
    useTheme,
    Card
} from '@mui/material';
import { CircularProgressProps } from '@mui/material/CircularProgress';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useIntl } from 'react-intl';

// project imports
import DrawerProduct from '../ThirdLevel/DrawerProduct';
import PerfectScrollbar from 'react-perfect-scrollbar';

function CircularProgressWithLabel(props: CircularProgressProps & { value: number }) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
                variant="determinate"
                // eslint-disable-next-line no-nested-ternary
                color={props.value <= 34 ? 'error' : props.value >= 35 && props.value <= 80 ? 'warning' : 'success'}
                size={60}
                {...props}
            />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Typography variant="caption" component="div" color="text.secondary">{`${Math.round(props.value)}%`}</Typography>
            </Box>
        </Box>
    );
}
interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}
const ExpandMore = styled((props: ExpandMoreProps) => {
    const { ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
    })
}));
// ===========================|| DATA WIDGET - PROJECT TABLE CARD ||=========================== //

const TableProducts = ({ products, typeReq }: { products: any; typeReq: string }) => {
    const theme = useTheme();
    const intl = useIntl();

    const [isExpanded, setIsExpanded] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [idProd, setIdProd] = useState<number | null>(null);
    const [limit, setLimit] = useState(20);

    const handledClickProduct =
        (open: boolean, prod: number | null = null) =>
        (event: React.KeyboardEvent | React.MouseEvent) => {
            setModalIsOpen(open);
            if (prod !== null) {
                setIdProd(prod);
            }
        };
    /* const [idProd, setIdProd] = useState<number>(0); */
    const handleExpandClick = () => {
        setIsExpanded(!isExpanded);
    };

    const handleLoadMore = () => {
        setLimit((prevLimit) => prevLimit + 20);
    };

    return (
        <>
            {products?.length && products && (
                <Card sx={{ width: '100%', background: theme.palette.background.paper }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ pl: 3 }}> {intl.formatMessage({ id: 'name' })}</TableCell>
                                <TableCell>{intl.formatMessage({ id: 'reference_code' })}</TableCell>
                                <TableCell>EAN / UPC</TableCell>
                                <TableCell align="right" sx={{ pr: 3 }}>
                                    {intl.formatMessage({ id: 'complete' })}
                                </TableCell>
                                <TableCell align="right" sx={{ pr: 3 }} />
                            </TableRow>
                        </TableHead>
                    </Table>
                    <PerfectScrollbar
                        style={{
                            height: '100%',
                            maxHeight: 850,
                            overflowX: 'hidden'
                        }}
                    >
                        <TableContainer>
                            <Table>
                                <TableBody>
                                    {products?.length &&
                                        products?.slice(0, limit).map((row: any, index: Key | null | undefined) => (
                                            <TableRow hover key={index}>
                                                <TableCellStyled title={row?.productName ?? ''} sx={{ maxWidth: 120 }}>
                                                    {row?.productName}
                                                </TableCellStyled>
                                                <TableCellStyled title={row?.productReferenceCode ?? ''}>
                                                    {row?.productReferenceCode}
                                                </TableCellStyled>
                                                <TableCellStyled>
                                                    {row?.eanUpc?.length > 1 ? (
                                                        <>
                                                            <div style={{ display: 'flex' }}>
                                                                <p>{row?.eanUpc[0]}</p>
                                                                <ExpandMore
                                                                    expand={isExpanded}
                                                                    onClick={handleExpandClick}
                                                                    aria-expanded={isExpanded}
                                                                    aria-label="show more"
                                                                    style={{ marginLeft: '2px' }}
                                                                >
                                                                    <ExpandMoreIcon />
                                                                </ExpandMore>
                                                            </div>
                                                            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                                                {row?.eanUpc?.map((ean: any) => <p>{ean}</p>)}
                                                            </Collapse>
                                                        </>
                                                    ) : (
                                                        <p>{row?.eanUpc}</p>
                                                    )}
                                                </TableCellStyled>
                                                <TableCellStyled align="right" sx={{ pr: 3 }}>
                                                    <CircularProgressWithLabel value={row?.completeness} />
                                                </TableCellStyled>
                                                <TableCell>
                                                    <Button
                                                        size="small"
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={handledClickProduct(true, row?.productId)}
                                                    >
                                                        {intl.formatMessage({ id: 'show_more' })}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    {limit < products?.length && (
                                        <TableRow>
                                            <TableCell colSpan={5} style={{ textAlign: 'center' }}>
                                                <Button variant="contained" color="primary" onClick={handleLoadMore}>
                                                    {intl.formatMessage({ id: 'load_more' })}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </PerfectScrollbar>
                </Card>
            )}
            <DrawerProduct handledClickProduct={handledClickProduct} openModal={modalIsOpen} idProd={idProd} typeReq={typeReq} />
        </>
    );
};

export default TableProducts;

const TableCellStyled = styled(TableCell)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
